import { createFileRoute } from '@tanstack/react-router';
import SuccessPage from '~/components/OrderKitsStore/StripeFlow/SuccessPage';

export const Route = createFileRoute('/_authed/order-kits/success')({
  component: SuccessPage,
});
